var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-bg"},[_c('el-carousel',{attrs:{"interval":8000,"indicator-position":"none","height":_vm.swiperHeight + 'px'}},_vm._l((_vm.banner_img),function(item){return _c('el-carousel-item',{key:item.index},[_c('el-image',{attrs:{"src":item.img,"fit":"fill"}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74188959","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mcommon/Swiper.vue
// module id = null
// module chunks = 